module.exports = __webpack_public_path__ + "img/no_data.1894d722.svg";